import { PropsWithChildren, useMemo } from 'react'
import config from 'config'
import { BrandProfileProvider } from '@vp/react-brand'
import { usePersonalizationConfig } from './hooks/usePersonalizationConfig'

import { ReduxBridge } from './ReduxBridge'
import { UploadsProvider } from './UploadsProvider'
import { SchemesProvider } from '../Schemes'
import { PersonalizationManager } from './PersonalizationManager'
import { PersonalizationModal } from './Views/PersonalizationModal'
import { useIdentity } from '@vp/ubik-context'

export const DesignPersonalizationProvider = ({ children }: PropsWithChildren) => {
  const { identity } = useIdentity()
  const brandAuth = useMemo(() => (identity?.authorizationHeader ? { type: '', token: identity.authorizationHeader } : ''), [identity])

  const { imageCopyKey, mode, isEnabled } = usePersonalizationConfig()

  // If personalization is not enabled, return only the children
  if (!isEnabled) {
    return <>{children}</>
  }

  return (
    <BrandProfileProvider includeSpeculations authorization={brandAuth} requestor={config.appName}>
      <SchemesProvider defaultToPhoto={imageCopyKey === 'Photo'}>
        <PersonalizationManager>
          <ReduxBridge />
          <UploadsProvider>
            {children}
            {mode === 'modal' && <PersonalizationModal />}
          </UploadsProvider>
        </PersonalizationManager>
      </SchemesProvider>
    </BrandProfileProvider>
  )
}
